export default __webpack_public_path__ + "static/media/G0040.Picture1.1722507000000.a86a1b59.jpg";